// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DropDownMenu-menuBg-DXdJB {
    width: 78px;
    height: 44px;
    background: transparent;
    border-radius: 22px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    gap: 20px;
    padding: 0 10px 0 12px;
    margin-left: 10px;
    cursor: pointer;
}

.DropDownMenu-menuBg-DXdJB:hover {
    background: transparent !important;
}

.DropDownMenu-icon-VZZhF {
    height: 50px
}

.DropDownMenu-userAvatar-hYb8g {
    border-radius: 50%;
    margin-right: 15px;
}

.DropDownMenu-notification-Br5Fr {
    background: var(--alert-color);
    height: 8px;
    width: 8px;
    position: absolute;
    top: 3px;
    right: 10px;
    border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/components/DropDownMenu/DropDownMenu.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,SAAS;IACT,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,kBAAkB;AACtB","sourcesContent":[".menuBg {\n    width: 78px;\n    height: 44px;\n    background: transparent;\n    border-radius: 22px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 20px;\n    padding: 0 10px 0 12px;\n    margin-left: 10px;\n    cursor: pointer;\n}\n\n.menuBg:hover {\n    background: transparent !important;\n}\n\n.icon {\n    height: 50px\n}\n\n.userAvatar {\n    border-radius: 50%;\n    margin-right: 15px;\n}\n\n.notification {\n    background: var(--alert-color);\n    height: 8px;\n    width: 8px;\n    position: absolute;\n    top: 3px;\n    right: 10px;\n    border-radius: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuBg": `DropDownMenu-menuBg-DXdJB`,
	"icon": `DropDownMenu-icon-VZZhF`,
	"userAvatar": `DropDownMenu-userAvatar-hYb8g`,
	"notification": `DropDownMenu-notification-Br5Fr`
};
module.exports = ___CSS_LOADER_EXPORT___;
